exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/wamp/www/sportal/pmi/web/src/app/main/lead/lead.component.css
// module id = ../../../../../src/app/main/lead/lead.component.css
// module chunks = main